/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetOrderRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetOrderResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getOrder = (request:GetOrderRequest, options?: CashRequestOptions) => post<GetOrderRequest, GetOrderResponse>("/cash-app/local/order/get", request, {...options, rejectOnError: true })